require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./crime-reducing-effects-and-financial-impact-pf-improved-lighting.json") })
        }
      }, "path---crime-reducing-effects-and-financial-impact-pf-improved-lighting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---crime-reducing-effects-and-financial-impact-pf-improved-lighting!./.cache/json/crime-reducing-effects-and-financial-impact-pf-improved-lighting.json
// module id = 866
// module chunks = 231608221292675